<script>
    import Iconbtn from "./Iconbtn.svelte";
    import { shownote } from '../store.js';
    import { createEventDispatcher } from 'svelte';
    import { slide } from 'svelte/transition';
    const dispatch = createEventDispatcher();
    const del = () => {
        dispatch('del')
    };
    const edit = () => {
        dispatch('edit')
    };
    const copy = () => {
        if(actions.copiable){
            dispatch('copy')
        }
    };
    const add = () => {
        if(actions.addable){
            dispatch('add')
        }
    };
    const reduce = () => {
        if(actions.reducable){
            dispatch('reduce')
        }
    };
    export let actions;
    export let price;
    export let nums;
</script>
<div class="action-top" transition:slide|local="{{duration: 150 }}">
    <div class="ab-left">
        <span>
            <Iconbtn below={false} text={'总计'} shownote={$shownote}>
                <svg t="1661869113951" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="7555" width="81" height="81"><path d="M783.6119140625001 167.56542968750006L575.0254882812499 463.25761718749993H739.4169921875v65.36689453125H547.9103515625v90.02460937500001H739.4169921875v66.18427734375001H547.9103515625v131.08710937499998H449.38144531250003V684.8333984374999H250.86464843749997v-66.18427734375001h198.516796875V528.6245117187499H250.86464843749997v-65.36689453125h169.3740234375L213.64560546874998 167.56542968750006h111.08935546875c96.53642578125 146.85029296874998 155.141015625 240.00644531250003 175.921875 279.39638671875h1.9924804687499997c7.046191406249999-16.225488281249998 26.33115234375-48.89091796875 57.786328125000004-97.9962890625L678.5711914062499 167.56542968750006h105.04072265625001z" p-id="7556"></path></svg>
            </Iconbtn>
        </span>
        <i class="count">{price}</i>
    </div>
    <div class="ab-right">
        <span>
            <Iconbtn below={true} text={'减一注'} shownote={$shownote} on:submit={reduce}>
                <svg t="1661868949798" class="{actions.reducable ? 'icon' : 'icon-disable'}" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1942" width="81" height="81"><path d="M801.171 547.589H222.83c-17.673 0-32-14.327-32-32s14.327-32 32-32h578.341c17.673 0 32 14.327 32 32s-14.327 32-32 32z" p-id="1943"></path></svg>
            </Iconbtn>
        </span>
        <span>
            <div class="btn">{nums}</div>
        </span>
        <span>
            <Iconbtn below={false} text={'加一注'} shownote={$shownote} on:submit={add}>
                <svg t="1661868935977" class="{actions.addable ? 'icon' : 'icon-disable'}" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1790" width="81" height="81"><path d="M801.171 483.589H544V226.418c0-17.673-14.327-32-32-32s-32 14.327-32 32v257.171H222.83c-17.673 0-32 14.327-32 32s14.327 32 32 32H480v257.17c0 17.673 14.327 32 32 32s32-14.327 32-32v-257.17h257.171c17.673 0 32-14.327 32-32s-14.327-32-32-32z" p-id="1791"></path></svg>
            </Iconbtn>
        </span>
        <span>
            <Iconbtn below={true} text={'编辑'} shownote={$shownote} on:submit={edit}>
                <svg t="1661947826394" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5297" width="81" height="81"><path d="M832.161 351.79c-17.673 0-32 14.327-32 32v479.85H224.037V223.784h414.605c17.673 0 32-14.327 32-32 0-17.673-14.327-32-32-32H192.037c-17.673 0-32 14.327-32 32V895.64c0 17.673 14.327 32 32 32h640.124c17.673 0 32-14.327 32-32V383.79c0-17.673-14.327-32-32-32z" fill="" p-id="5298"></path><path d="M485.612 534.222c6.249 6.248 14.438 9.372 22.627 9.372s16.379-3.124 22.627-9.372l321.407-321.406c12.496-12.497 12.496-32.758 0-45.255-12.498-12.497-32.759-12.497-45.255 0L485.612 488.967c-12.497 12.496-12.497 32.758 0 45.255zM736 627c0-17.673-14.327-32-32-32H322c-17.673 0-32 14.327-32 32s14.327 32 32 32h382c17.673 0 32-14.327 32-32zM322 725c-17.673 0-32 14.327-32 32s14.327 32 32 32h251c17.673 0 32-14.327 32-32s-14.327-32-32-32H322z" fill="" p-id="5299"></path></svg>
            </Iconbtn>
        </span>
        <span>
            <Iconbtn below={false} text={'复制'} shownote={$shownote} on:submit={copy}>
                <svg t="1661868636577" class="{actions.copiable ? 'icon' : 'icon-disable'}" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2425" width="81" height="81"><path d="M96.1 575.7a32.2 32.1 0 1 0 64.4 0 32.2 32.1 0 1 0-64.4 0Z" p-id="2426"></path><path d="M742.1 450.7l-269.5-2.1c-14.3-0.1-26 13.8-26 31s11.7 31.3 26 31.4l269.5 2.1c14.3 0.1 26-13.8 26-31s-11.7-31.3-26-31.4zM742.1 577.7l-269.5-2.1c-14.3-0.1-26 13.8-26 31s11.7 31.3 26 31.4l269.5 2.1c14.3 0.2 26-13.8 26-31s-11.7-31.3-26-31.4z" p-id="2427"></path><path d="M736.1 63.9H417c-70.4 0-128 57.6-128 128h-64.9c-70.4 0-128 57.6-128 128v128c-0.1 17.7 14.4 32 32.2 32 17.8 0 32.2-14.4 32.2-32.1V320c0-35.2 28.8-64 64-64H289v447.8c0 70.4 57.6 128 128 128h255.1c-0.1 35.2-28.8 63.8-64 63.8H224.5c-35.2 0-64-28.8-64-64V703.5c0-17.7-14.4-32.1-32.2-32.1-17.8 0-32.3 14.4-32.3 32.1v128.3c0 70.4 57.6 128 128 128h384.1c70.4 0 128-57.6 128-128h65c70.4 0 128-57.6 128-128V255.9l-193-192z m0.1 63.4l127.7 128.3H800c-35.2 0-64-28.8-64-64v-64.3h0.2z m64 641H416.1c-35.2 0-64-28.8-64-64v-513c0-35.2 28.8-64 64-64H671V191c0 70.4 57.6 128 128 128h65.2v385.3c0 35.2-28.8 64-64 64z" p-id="2428"></path></svg>
            </Iconbtn>
        </span>
        <span style="width: 1rem;"></span>
        <span>
            <Iconbtn below={true} text={'删除'} shownote={$shownote} on:submit={del}>
                <svg t="1661947427763" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4048" width="81" height="81"><path d="M550.848 502.496l308.64-308.896a31.968 31.968 0 1 0-45.248-45.248l-308.608 308.896-308.64-308.928a31.968 31.968 0 1 0-45.248 45.248l308.64 308.896-308.64 308.896a31.968 31.968 0 1 0 45.248 45.248l308.64-308.896 308.608 308.896a31.968 31.968 0 1 0 45.248-45.248l-308.64-308.864z" p-id="4049"></path></svg>
            </Iconbtn>
        </span>
    </div>
</div>
<style>
    .action-top {
        position: relative;
        width: 100%;
        height: 1.8rem;
        padding-top: .2rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .action-top .ab-left{
        display: flex;
        justify-content: flex-start;
    }
    .action-top .ab-right{
        display: flex;
        justify-content: flex-end;
    }
    .action-top span {
        display: inline-block;
        width: 1.6rem;
        height: 1.6rem;
    }
    .action-top .count{
        font-family: 'Baloo Chettan 2';
        font-style: normal;
        display: inline-block;
        height: 1.6rem;
        line-height: 1.6rem;
    }
    .action-top .btn{
        position: relative;
        width: 100%;
        height: 100%;
        display: inline-flex;
        justify-content: center;
        align-items: center;
        font-family: 'Baloo Chettan 2';
        font-size: 1rem;
        color: #1363DF;
    }
    .action-top svg{
        width: 80%;
        height: 80%;
    }
    .action-top .icon{
        fill: #141E27;
    }
    .action-top .icon-disable{
        fill: #B2B1B9;
    }
</style>